// extracted by mini-css-extract-plugin
export default {"cta":"PG-z","disabled":"QG-z"};